import { Announcement03, Shield03, SlashCircle01, Zap } from "@untitledui/icons";
import { cx } from "@/utils/cx";

export const AdThumbnailBadge = () => (
  <div className="w-[90%] px-[6px] py-[3px] absolute bottom-1 left-1/2 transform -translate-x-1/2 flex items-center justify-center rounded-full bg-utility-gray-blue-50 gap-0.5">
    <Announcement03 className="h-2.5 w-2.5 text-utility-gray-blue-700" />
    <span className="text-[10px] font-semibold leading-none text-utility-gray-blue-700">Ad</span>
  </div>
);

export const AdCampaignTag = () => (
  <div className="flex flex-row items-center gap-1 rounded-md bg-utility-gray-blue-50 border border-utility-gray-blue-200 px-2 py-1 w-fit">
    <Announcement03 className="w-3 h-3 text-utility-gray-blue-700" strokeWidth={2} />
    <span className="text-xs font-medium text-utility-gray-blue-700">In Ad Campaign</span>
  </div>
);

export const GmvMaxCampaignTag = () => (
  <span className="inline-flex items-center gap-0.5 shrink-0 rounded bg-utility-brand-50 border border-utility-brand-200 px-1.5 py-0.5">
    <Zap className="w-3 h-3 text-utility-brand-700" strokeWidth={2} />
    <span className="text-[10px] font-medium leading-none text-utility-brand-700">GMV Max</span>
  </span>
);

export const ExcludedTag = () => (
  <span className="inline-flex items-center gap-0.5 shrink-0 rounded bg-utility-warning-50 border border-utility-warning-200 px-1.5 py-0.5">
    <SlashCircle01 className="w-3 h-3 text-utility-warning-700" strokeWidth={2} />
    <span className="text-[10px] font-medium leading-none text-utility-warning-700">Excluded</span>
  </span>
);

export const QuarantineTag = ({ className }: { className?: string }) => (
  <div
    className={cx(
      "flex flex-row items-center gap-1 rounded-full bg-utility-gray-blue-50 border border-utility-gray-blue-200 px-2 py-1 w-fit",
      className,
    )}
  >
    <Shield03 className="w-4 h-4 shrink-0 text-utility-gray-blue-700" strokeWidth={2} />
    <span className="text-sm font-medium text-utility-gray-blue-700 whitespace-nowrap">
      Quarantined - excluded from ads
    </span>
  </div>
);
